import React from "react";
import { motion } from "framer-motion";
import commentsIllustration from "../../assets/comments-illustration.png";

const CommentValue = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-primary/5 via-blue-500/5 to-primary/10 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/3 to-blue-400/5" />
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6">
              Comments are for <span className="text-primary">connection</span>,
              not chaos
            </h2>
            <p className="text-lg md:text-xl text-foreground/90 leading-relaxed">
              Your comment sections are the{" "}
              <span className="font-semibold text-foreground">
                most underutilized direct conversation space with your community
              </span>
              . Strong brand loyalty is forged (or fractured) here, and savvy
              social media professionals understand this unstructured
              environment must be streamlined and accessible.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={commentsIllustration}
                alt="Social media comment interfaces showing organized community engagement"
                className="w-full h-auto"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CommentValue;
